import { Injectable } from '@angular/core';
import { SharedService } from "./shared.service";
import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment'
import { User } from '../Models/user';

@Injectable()
export class UserService {

  constructor(private http: HttpClient, private _sharedService: SharedService) { }

  public GetUserMenu(EmployeeId:number) {
    let Data = {
      EmployeeId : EmployeeId
    }
    let path:any  = environment.baseAppUrl + "scripts/menu/" + EmployeeId + ".htm";
    return this._sharedService.GetStaticContent(path);
  }


  public GetUserDetail(EmployeeId:number){
    let Data:any = {
      "EmployeeId" :EmployeeId
    }
    return this._sharedService.Get("Users/GetUserDetail",Data);      
  }



  
}
